import { lazy } from 'react'

const AddsRoutes = [
    {
        path: '/reklama',
        component: lazy(() => import('../../views/bookmakers-adds')),
        exact: true,
        meta: {
            authRoute: false
        }
    },
    {
        path: '/superbet-liga-mistrzow',
        component: lazy(() => import('../../views/bookmakers-adds/superbet/SuperBetLigaMistrzowView')),
        exact: true,
        meta: {
            authRoute: false
        }
    }
]

export default AddsRoutes
